import flatten from 'lodash/flatten';
import { UserLevel } from '@common/types/api';

export interface NewFeature {
  path: RegExp;
  id: string;
  levelId?: UserLevel[];
}

const featuresList: Record<string, NewFeature[]> = {
  '1.22.0': [{
    path: /^\/device\/.*\/diagram$/g,
    id: 'color-palette',
  }],
  '1.23.1': [{
    path: /^\/device\/.*\/diagram(\/dataPoints)?$/g,
    id: 'line-type-and-aggregation',
  }],
  '1.24.0': [{
    path: /^\/device\/.*\/general$/g,
    id: 'notifications-language',
  }],
  '1.30.0': [{
    path: /^\/device\/.*\/diagram\/graph$/g,
    id: 'graph-download',
    levelId: [UserLevel.AdvancedUser],
  }],
};

export const getVersions = () => Object.keys(featuresList);

const filterFeatures = (
  features: NewFeature[],
  userLevel: UserLevel | undefined,
) => {
  if (userLevel) {
    return features.filter((feature) =>
      feature.levelId == null || feature.levelId.includes(userLevel)
    );
  }
  return features;
};

export const getAllNewFeatures = (
  userLevel: UserLevel | undefined,
) => {
  return filterFeatures(flatten(Object.values(featuresList)), userLevel);
};

export const getVersionNewFeatures = (
  version: string,
  userLevel: UserLevel | undefined,
) => {
  return filterFeatures(featuresList[version] ?? [], userLevel);
};
